import { Dialog, AppBar, Toolbar, Typography, Button, DialogContent, Grid, TextField, DialogActions, FormControlLabel, Switch } from "@mui/material"
import { useState, useRef, useEffect } from "react"
import { useLimitacaoConsumoService } from "../../../../../use-cases/limitacao-consumo"
import { useNavigationService } from "../../../../../use-cases/navigation"
import { onlyNumbers } from "../../../../../utils"
import { useAppSelector } from "../../../../hooks/store-hooks"
import { ITipoUsuario } from "../../../../../application/models"
import CloseIcon from '@mui/icons-material/Close'

export const FormUpdateTravaConsumoPerfil = () => {
    const { updateLimitacaoConsumoPerfilForm } = useAppSelector((state) => state.limitacaoConsumo)
    const { currentUser } = useAppSelector((state) => state.user)

    const [loading, setLoading] = useState<boolean>(true)
    const isFirstRender = useRef(false)

    const isDemais = currentUser?.IdVelesPerfilInterno === ITipoUsuario.USUARIO_VELES_DEMAIS
    const isTecnologiaDaInformacao = currentUser?.IdVelesPerfilInterno === ITipoUsuario.TECNOLOGIA_DA_INFORMACAO
    const isCliente = currentUser?.IdVelesPerfilInterno === ITipoUsuario.USUARIO_CLIENTE
    const canEdit = isDemais || isTecnologiaDaInformacao || isCliente

    const {
        setUpdateLimitacaoConsumoPerfilOpenForm,
        setUpdateLimitacaoConsumoPerfilFormQuantidade,
        setUpdateLimitacaoConsumoPerfilFormAtivo,
        updateLimitacaoConsumoPerfil
    } = useLimitacaoConsumoService()

    const { navigateTo } = useNavigationService()

    useEffect(() => {
        if (!isFirstRender.current) {
            setLoading(false)
            isFirstRender.current = true

            const { IdLimitacaoConsumoPerfil, IdGrupoTrava, IdPerfil } = updateLimitacaoConsumoPerfilForm.fields
            const hasValidId = (IdLimitacaoConsumoPerfil && IdLimitacaoConsumoPerfil > 0) || (IdGrupoTrava && IdGrupoTrava > 0)
            if (!hasValidId || !IdPerfil || IdPerfil === 0) {
                navigateTo({ route: '/dashboard/trava/consumo' })
            }
        }
    }, [navigateTo, updateLimitacaoConsumoPerfilForm.fields.IdLimitacaoConsumoPerfil, updateLimitacaoConsumoPerfilForm.fields.IdPerfil])

    const handleClose = () => {
        setUpdateLimitacaoConsumoPerfilOpenForm({ open: false })
    }

    return (
        loading ? <></> : (
            <Dialog
                open={true}
                fullScreen
                disableEscapeKeyDown
                onClose={handleClose}
                scroll={'paper'}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <Typography sx={{ ml: 2, flex: 1 }} textTransform={"uppercase"} fontWeight={"bold"} variant="h6" component="div">
                            {canEdit ? 'Atualizar trava de consumo (perfil)' : 'Visualizar trava de consumo (perfil)'}
                        </Typography>
                        <Button
                            color="inherit"
                            startIcon={<CloseIcon />}
                            onClick={handleClose}
                            aria-label="close"
                        >
                            Fechar
                        </Button>
                    </Toolbar>
                </AppBar>
                <DialogContent dividers={true}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={8}>
                            <TextField
                                value={
                                    updateLimitacaoConsumoPerfilForm.fields.Quantidade === 0 ? ''
                                        : updateLimitacaoConsumoPerfilForm.fields.Quantidade.toLocaleString('pt-BR')
                                }
                                onChange={(e) => {
                                    setUpdateLimitacaoConsumoPerfilFormQuantidade({
                                        Quantidade: Number(onlyNumbers(e.target.value))
                                    })
                                }}
                                InputLabelProps={{ shrink: true }}
                                name="quantidade"
                                fullWidth
                                id="quantidade"
                                label="Quantidade"
                                autoFocus
                                disabled={!canEdit}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <FormControlLabel
                                label={updateLimitacaoConsumoPerfilForm.fields.Ativo === true ? 'Trava de consumo ativa' : 'Trava de consumo inativa'}
                                control={
                                    <Switch
                                        checked={updateLimitacaoConsumoPerfilForm.fields.Ativo}
                                        onChange={(e) => {
                                            setUpdateLimitacaoConsumoPerfilFormAtivo({
                                                Ativo: e.target.checked
                                            })
                                        }}
                                        name="Ativo"
                                        color="primary"
                                        disabled={!canEdit}
                                    />
                                }
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Fechar</Button>
                    {canEdit && (
                        <Button
                            onClick={() => void updateLimitacaoConsumoPerfil()}
                            variant="contained"
                        >
                            Atualizar trava de consumo
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
        )
    )
}

